/** @jsx jsx */
import { jsx } from "theme-ui"

export default ({
  children,
  bg = "darkPurple",
  color = "white",
  onClick,
  styles,
  hoverStyles,
  type,
  disabled,
}) => (
  <button
    sx={{
      variant: "buttons.primary",
      color,
      bg,
      "&:hover, &:active": {
        bg: "purple",
        ...hoverStyles
      },
      ...styles,
    }}
    onClick={onClick}
    type={type}
    disabled={disabled}
  >
    {children}
  </button>
)
